import {
  DUMMY_TENANT_CODE,
  LOCAL_API_ENDPOINT,
  LOCAL_LIFF_ENDPOINT
} from '__tests__/dummyData';

export const LIFF_ID = process.env.REACT_APP_LIFF_ID as string;
export const APP_LIFF_ENDPOINT =
  process.env.REACT_APP_LIFF_ENDPOINT || LOCAL_LIFF_ENDPOINT;
export const CENTRAL_API_ENDPOINT = process.env.REACT_APP_CENTRAL_API_ENDPOINT;
export const FEATURES_API_ENDPOINT =
  process.env.REACT_APP_FEATURES_API_ENDPOINT || LOCAL_API_ENDPOINT;
export const RESERVATIONS_API_ENDPOINT =
  process.env.REACT_APP_RESERVATIONS_API_ENDPOINT;
export const STORES_API_ENDPOINT =
  process.env.REACT_APP_STORES_API_ENDPOINT || LOCAL_API_ENDPOINT;
export const NOTIFICATIONS_API_ENDPOINT =
  process.env.REACT_APP_NOTIFICATIONS_API_ENDPOINT || LOCAL_API_ENDPOINT;
export const DIGICLUEPLUS_API_ENDPOINT =
  process.env.REACT_APP_DIGICLUEPLUS_API_ENDPOINT || LOCAL_API_ENDPOINT;
export const MEMBERSHIP_API_ENDPOINT =
  process.env.REACT_APP_FEATURES_API_ENDPOINT || LOCAL_API_ENDPOINT;
export const GA_TRACKING_ID = process.env.REACT_APP_GTM_ID;

export const API_RESPONSE_STATUS = {
  SUCCEEDED: 'succeeded',
  FAILED: 'failed'
} as const;

export const TOAST_ERROR_MESSAGE =
  'エラーが発生しております。暫く経ってからもう一度お試しください';

// NOTE: tenant code is included in the location path: FRONT_ENDPOINT/tenant_code/*
// NOTE:自動テストをするために初期値が必要。
// Menu画面のリンク集取得APIにて、自動テスト時に src/api/index.tsx のaxios.createのTENANT_CODEが取得できない関係で
// baseURLの末尾が削除された状態でリクエストされてしまう
export const TENANT_CODE = location.pathname.split('/')[1] || DUMMY_TENANT_CODE;

export const NOW_LOADING = '読み込み中...';

export const PREFECTURES = [
  {
    id: '1',
    value: '北海道'
  },
  {
    id: '2',
    value: '青森県'
  },
  {
    id: '3',
    value: '岩手県'
  },
  {
    id: '4',
    value: '宮城県'
  },
  {
    id: '5',
    value: '秋田県'
  },
  {
    id: '6',
    value: '山形県'
  },
  {
    id: '7',
    value: '福島県'
  },
  {
    id: '8',
    value: '茨城県'
  },
  {
    id: '9',
    value: '栃木県'
  },
  {
    id: '10',
    value: '群馬県'
  },
  {
    id: '11',
    value: '埼玉県'
  },
  {
    id: '12',
    value: '千葉県'
  },
  {
    id: '13',
    value: '東京都'
  },
  {
    id: '14',
    value: '神奈川県'
  },
  {
    id: '15',
    value: '新潟県'
  },
  {
    id: '16',
    value: '富山県'
  },
  {
    id: '17',
    value: '石川県'
  },
  {
    id: '18',
    value: '福井県'
  },
  {
    id: '19',
    value: '山梨県'
  },
  {
    id: '20',
    value: '長野県'
  },
  {
    id: '21',
    value: '岐阜県'
  },
  {
    id: '22',
    value: '静岡県'
  },
  {
    id: '23',
    value: '愛知県'
  },
  {
    id: '24',
    value: '三重県'
  },
  {
    id: '25',
    value: '滋賀県'
  },
  {
    id: '26',
    value: '京都府'
  },
  {
    id: '27',
    value: '大阪府'
  },
  {
    id: '28',
    value: '兵庫県'
  },
  {
    id: '29',
    value: '奈良県'
  },
  {
    id: '30',
    value: '和歌山県'
  },
  {
    id: '31',
    value: '鳥取県'
  },
  {
    id: '32',
    value: '島根県'
  },
  {
    id: '33',
    value: '岡山県'
  },
  {
    id: '34',
    value: '広島県'
  },
  {
    id: '35',
    value: '山口県'
  },
  {
    id: '36',
    value: '徳島県'
  },
  {
    id: '37',
    value: '香川県'
  },
  {
    id: '38',
    value: '愛媛県'
  },
  {
    id: '39',
    value: '高知県'
  },
  {
    id: '40',
    value: '福岡県'
  },
  {
    id: '41',
    value: '佐賀県'
  },
  {
    id: '42',
    value: '長崎県'
  },
  {
    id: '43',
    value: '熊本県'
  },
  {
    id: '44',
    value: '大分県'
  },
  {
    id: '45',
    value: '宮崎県'
  },
  {
    id: '46',
    value: '鹿児島県'
  },
  {
    id: '47',
    value: '沖縄県'
  }
];

export const Z_INDEX_CONST = {
  header: 1000
} as const;

export const FALLBACK_IMAGES = {
  square:
    'data:image/webp;base64,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',
  rect: 'data:image/webp;base64,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'
};
